const PortugalSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112177)">
      <path
        d="M0 20.0011C0 28.6004 5.4275 35.9312 13.0434 38.7571L14.7826 20.0011L13.0434 1.24512C5.4275 4.07105 0 11.4018 0 20.0011Z"
        fill="#6DA544"
      />
      <path
        d="M40.0001 20C40.0001 8.95437 31.0457 0 20.0001 0C17.5537 0 15.2102 0.440078 13.0435 1.24398V38.756C15.2102 39.56 17.5537 40 20.0001 40C31.0457 40 40.0001 31.0456 40.0001 20Z"
        fill="#D80027"
      />
      <path
        d="M13.0429 26.9559C16.8849 26.9559 19.9994 23.8414 19.9994 19.9995C19.9994 16.1575 16.8849 13.043 13.0429 13.043C9.20095 13.043 6.08643 16.1575 6.08643 19.9995C6.08643 23.8414 9.20095 26.9559 13.0429 26.9559Z"
        fill="#FFDA44"
      />
      <path
        d="M9.13086 16.5215V20.8693C9.13086 23.0304 10.8827 24.7823 13.0439 24.7823C15.2051 24.7823 16.957 23.0305 16.957 20.8693V16.5215H9.13086Z"
        fill="#D80027"
      />
      <path
        d="M13.0436 22.1733C12.3244 22.1733 11.7393 21.5882 11.7393 20.8689V19.1299H14.3479V20.869C14.3479 21.5882 13.7628 22.1733 13.0436 22.1733Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112177">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default PortugalSvg;
